import { data } from "autoprefixer";

// Define keys for local and session storage
const LS_KEY = {
    token: "token",
    universityId: "universityId",
    user: "user",
    navigateOnLogin: "navigateOnLogin",
    howItWorksModal: "hasSeenHowItWorksModal"
};

const SS_KEY = {
    sessionKey: "sessionKey",
};

// Local storage functions
// Set to LocalStorage
const setInLocalStorage = {
    token: (data) => {
        localStorage.setItem(
            LS_KEY.token,
            `${data}` /* "Bearer" + " " + data */
        );
    },
    universityId: (data) => {
        return localStorage.setItem(LS_KEY.universityId, `${data}`);
    },
    user: (data) => {
        return localStorage.setItem(LS_KEY.user, JSON.stringify(data))
    },
    navigateOnLogin: (data) => {
        return localStorage.setItem(LS_KEY.navigateOnLogin, data)
    },
    howItWorksModal: (data) => {
        return localStorage.setItem(LS_KEY.howItWorksModal, data)
    }
};

// Get from Local Storage
const fetchFromLocalStorage = {
    token: () => {
        return localStorage.getItem(LS_KEY.token);
    },
    universityId: () => {
        return localStorage.getItem(LS_KEY.universityId);
    },
    user: () => {
        return JSON.parse(localStorage.getItem(LS_KEY.user))
    },
    navigateOnLogin: () => {
        return localStorage.getItem(LS_KEY.navigateOnLogin)
    },
    howItWorksModal: () => {
        return localStorage.getItem(LS_KEY.howItWorksModal)
    }
};

// Delete From Local Storage
const destroyFromLocalStorage = {
    token: () => {
        return localStorage.removeItem(LS_KEY.token);
    },
    universityId: () => {
        return localStorage.removeItem(LS_KEY.universityId);
    },
    user: () => {
        return localStorage.removeItem(LS_KEY.user);
    },
    navigateOnLogin: () => {
        return localStorage.removeItem(LS_KEY.navigateOnLogin);
    },
    howItWorksModal: () => {
        return localStorage.removeItem(LS_KEY.howItWorksModal);
    }
};

// Session storage functions
// Set to Session Storage
const setInSessionStorage = {
    sessionKey: (data) => {
        sessionStorage.setItem(
            SS_KEY.sessionKey,
            data /* "Bearer" + " " + data */
        );
    },
};

// Get Session Storage
const fetchFromSessionStorage = {
    sessionKey: () => {
        return sessionStorage.getItem(SS_KEY.sessionKey);
    },
};

// Delete Session Storage
const destroyFromSessionStorage = {
    sessionKey: () => {
        sessionStorage.removeItem(SS_KEY.sessionKey);
    },
};

// Export all storage functions
export const storage = {
    setInLocalStorage,
    fetchFromLocalStorage,
    destroyFromLocalStorage,

    setInSessionStorage,
    fetchFromSessionStorage,
    destroyFromSessionStorage,
};
